import React, { Component } from 'react'

import alarm from '../../../../../assets/icons/alarm.svg';


export default class Mobile extends Component {
  render() {
    return (
      <div className="mobile-duties__features--item">
        <h2>هشدار</h2>
        <div className="mobile-float-input d-flex" onClick={() => this.props.openAlarm()}>
          <img src={alarm} className="mic" />
          <div className="mobile-float-input__value">
            {this.props.selectedAlarm ? this.props.selectedAlarm : 'هشدار را تنظیم کنید'}
          </div>
        </div>
        {
          this.props.alarm ?
            <div className="mobile-duty-alarms d-flex flex-column fadeAnimation">
              {
                this.props.alarms.map(item => (
                  <div className="mobile-duty-alarms__alarm d-flex" key={item.name}>
                    <input type="radio" name="alarm" defaultChecked={item.checked} onChange={() => { this.props.closeAlarm(item.name, item.id) }} />
                    <div className="mr-2">{item.name}</div>
                  </div>
                ))
              }
            </div> : null
        }
      </div >
    )
  }
}